import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from '../../core/upgraded-providers';
import { ResourceOrdersDataSource } from '../resource-orders/resource-orders.data-source';
import { default as RESOURCES } from '../resource';

@Component({
    selector: 'app-dlg-resource-orders',
    templateUrl: './dlg-resource-orders.component.pug',
    styleUrls: ['./dlg-resource-orders.component.less']
})
export class DlgResourceOrdersComponent implements OnInit {

    public shard: string;
    public sellList: any[] = [];
    public buyList: any[] = [];
    public statsList: any[] = [];
    public worldSize: { width: number, height: number };

    public resource;
    private _dataSource: ResourceOrdersDataSource;

    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _apiService: ApiService,
        public dialogRef: MatDialogRef<DlgResourceOrdersComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this._dataSource = new ResourceOrdersDataSource(this._apiService);

        this.shard = data.shard;
        this.resource = RESOURCES[data.resourceType];

        this.setData(data);
    }

    ngOnInit() {
        // This is hack to close by backdrop.
        const overlayWrapper = this.dialogRef['_overlayRef'].overlayElement.parentElement;

        overlayWrapper.addEventListener('click', ({ target }) => {
            if (overlayWrapper !== target) {
                return;
            }

            this.onClose();
        });
    }

    setData({ sellList, buyList, statsList, worldSize }) {
        this.sellList = sellList;
        this.buyList = buyList;
        this.statsList = statsList;
        this.worldSize = worldSize;
    }

    onRefresh(next) {
        this._dataSource.getData(this.data)
            .then((data) => this.setData(data))
            .then(() => next());
    }

    onChangeShard(shard) {
        this.data.shard = this.shard = shard;

        const resourceType = this.data.resourceType;

        try {
            const matchResourceType = location.hash.match(/market\/all\/.+\/(.+)/)[1];

            if (matchResourceType === resourceType) {
                this._router.navigate(['/market/all', shard, resourceType], {
                    relativeTo: this._route,
                    // replaceUrl: true
                });
            }
        } catch (ignore) {
            // Noop.
        }

        this._dataSource.getData(this.data)
            .then((data) => this.setData(data));
    }

    onClose() {
        this.dialogRef.close();
    }
}
